import { render } from "./TransactionReceipt.vue?vue&type=template&id=5b333714&ts=true"
import script from "./TransactionReceipt.vue?vue&type=script&lang=ts"
export * from "./TransactionReceipt.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/myittar_pharmacy_pos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__